import Vue from "vue";

Vue.filter("capitalize", function (value) {
  if (!value) return "";

  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter("capitalizeWord", function (value) {
  if (!value) return "";

  var splitStr = value.toLowerCase().split(" ");

  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(" ");
});

Vue.filter("averageRate", function (value, num_rate) {
  if (!value) return "";

  value = value / num_rate;
  return value.toFixed(1);
});

Vue.filter("currency", function (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter("utcDateToLocalDate", function (value, format = "yyyy-MM-dd HH:mm:ss") {
  if (!value) return "";

  const d = new Date(value);

  // 🔐 invalid date guard (CRITICAL)
  if (isNaN(d.getTime())) return "";

  return format ? d.format(format) : d;
});


// Vue.filter("utcDateToLocalDate", function (value, format = "yyyy-MM-dd HH:mm:ss") {
//   if (!value) return ""; // 🔐 guard

//   var isoDateString = new Date(value).toISOString();
//   var d = new Date(isoDateString);

//   if (format) {
//     // format the date
//     return d.format(format);
//   }
//   return d;
// });
